var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Message"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7769 13.4647C11.1079 13.4647 10.4409 13.2437 9.88292 12.8017L5.39792 9.18574C5.07492 8.92574 5.02492 8.45274 5.28392 8.13074C5.54492 7.80974 6.01692 7.75874 6.33892 8.01774L10.8199 11.6297C11.3829 12.0757 12.1759 12.0757 12.7429 11.6257L17.1789 8.01974C17.5009 7.75674 17.9729 7.80674 18.2349 8.12874C18.4959 8.44974 18.4469 8.92174 18.1259 9.18374L13.6819 12.7957C13.1199 13.2417 12.4479 13.4647 11.7769 13.4647",
    fill: "#6576FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3860_28332",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2H22.4999V21.5H1V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3860_28332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83888 20H16.6589C16.6609 19.998 16.6689 20 16.6749 20C17.8159 20 18.8279 19.592 19.6039 18.817C20.5049 17.92 20.9999 16.631 20.9999 15.188V8.32C20.9999 5.527 19.1739 3.5 16.6589 3.5H6.84088C4.32588 3.5 2.49988 5.527 2.49988 8.32V15.188C2.49988 16.631 2.99588 17.92 3.89588 18.817C4.67188 19.592 5.68488 20 6.82488 20H6.83888ZM6.82188 21.5C5.27888 21.5 3.90088 20.94 2.83688 19.88C1.65188 18.698 0.999878 17.032 0.999878 15.188V8.32C0.999878 4.717 3.51088 2 6.84088 2H16.6589C19.9889 2 22.4999 4.717 22.4999 8.32V15.188C22.4999 17.032 21.8479 18.698 20.6629 19.88C19.5999 20.939 18.2209 21.5 16.6749 21.5H16.6589H6.84088H6.82188Z",
    fill: "#6576FF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.52fd160a.svg";
export { ForwardRef as ReactComponent };